import type { ListItem } from "../list.type";

import { useEffect } from "react";

import { useInfiniteList } from "@/hooks/queries";
import { getApiPaginationTotal } from "@/services/api";

import { getListMetadata } from "../list-fetcher";
import { useListContext } from "../list.context";

export const useListFetcherLazyHandler = <
  DataItem extends ListItem = ListItem,
  Metadata = unknown,
>() => {
  const {
    model,
    withMetadata,
    fetchParams,
    enabled,
    neverStale,
    setListData,
    setListLazyInfos,
  } = useListContext<DataItem, Metadata>();

  const {
    data,
    pages,
    pagination,
    isLoading,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useInfiniteList<DataItem>({
    model,
    params: fetchParams,
    enabled,
    neverStale,
  });

  useEffect(() => {
    setListData({
      data,
      total: getApiPaginationTotal(pagination),
      // metadata objects contain the data for all the list items,
      // so let's just pick metadata objects from first page
      metadata: getListMetadata({ data: pages?.[0], withMetadata }),
      loading: isLoading || isFetchingNextPage,
      fetching: isFetching,
    });
  }, [data, isLoading, isFetching, isFetchingNextPage, withMetadata]);

  useEffect(() => {
    setListLazyInfos({ hasNextPage, fetchNextPage });
  }, [hasNextPage, fetchNextPage]);
};
